<mat-toolbar color="primary">
  <div class="flex items-center justify-between w-[90%] mx-auto">
    <a class="hidden xl:block" routerLink="/home">
      <h2 class="!text-xl">California Insulated Wire & Cable</h2>
    </a>

    <div class="flex gap-4 flex-1">
      <button
        class="mx-auto"
        mat-flat-button
        routerLink="/home"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        HOME
      </button>

      <button
        class="mx-auto"
        mat-flat-button
        *ngIf="!isOrdersManager()"
        routerLink="/quotes"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        QUOTES
      </button>

      <button
        class="mx-auto"
        mat-flat-button
        routerLink="/orders"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        ORDERS
      </button>

      <button
        class="mx-auto"
        mat-flat-button
        routerLink="/clients"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        CLIENTS
      </button>

      <button
        class="mx-auto"
        mat-flat-button
        routerLink="/products"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        PRODUCTS
      </button>

      <button
        class="mx-auto"
        mat-flat-button
        *ngIf="!isOrdersManager() && !isOrdersAdmin()"
        routerLink="/users"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        USERS
      </button>
    </div>

    @if (loggedInUser(); as user) {
      <button class="!uppercase" mat-flat-button [matMenuTriggerFor]="menu">
        WELCOME {{ user.firstName }}!
      </button>
    }

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="goToEditUser()">
        <span>Edit Details</span>
        <mat-icon>edit</mat-icon>
      </button>

      <button mat-menu-item (click)="launchChangePasswordDialog()">
        <span>Change Password</span>
        <mat-icon>repeat</mat-icon>
      </button>

      <button mat-menu-item (click)="logout()">
        <span>Log Out</span>
        <mat-icon>power_settings_new</mat-icon>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
